// This file is automatically generated. Do not edit manually.

import { Contact } from "src/api/generated/erp/db/types/tables/contact";
import { ContactUpdateService_UpdateRequest } from "src/api/generated/erp/contacts/service/contactUpdateService";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace SalesLeadContactsApi {
	export async function getContacts(args: { salesLeadId: number }): Promise<Array<Contact>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/crm/salesLeadContacts/getContacts",
			method: "POST",
			data: {
				salesLeadId: args.salesLeadId,
			},
		});
		return response as Array<Contact>;
	}

	export async function insert(args: { salesLeadId: number; contact: Contact }): Promise<number> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/crm/salesLeadContacts/insert",
			method: "POST",
			data: {
				salesLeadId: args.salesLeadId,
				contact: args.contact,
			},
		});
		return response as number;
	}

	export async function update(args: { contact: ContactUpdateService_UpdateRequest }): Promise<number> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/crm/salesLeadContacts/update",
			method: "POST",
			data: {
				contact: args.contact,
			},
		});
		return response as number;
	}

	export async function delete_(args: { contactId: number }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/crm/salesLeadContacts/delete",
			method: "POST",
			data: {
				contactId: args.contactId,
			},
		});
		return response as void;
	}
}
